module.exports = __webpack_public_path__ + "static/media/language.7bea3c97.svg";